import { Tooltip } from 'react-tooltip';
import styles from './TooltipWithModels.module.scss';
import { Icon, IconName } from 'src/components/Icon';
import { SVG_SIZE_S } from 'src/constants';
import { useBreakpoint } from 'src/hooks';
import { PortalWrapper } from 'src/components/PortalWrapper';

type TooltipWithModelsProps = {
  hoveredText: React.ReactNode;
  models: { icon: IconName; models: string }[];
  id: string;
};

export const TooltipWithModels = ({
  id,
  models,
  hoveredText,
}: TooltipWithModelsProps) => {
  const { isMobileOrTablet } = useBreakpoint();
  return (
    <>
      <div id={id}>{hoveredText}</div>
      <PortalWrapper>
        <div className={styles.root}>
          <Tooltip
            anchorSelect={`#${id}`}
            className={styles.tooltipWrapper}
            openOnClick={isMobileOrTablet}
            clickable
            place="top"
            offset={10}
            positionStrategy="fixed"
            opacity={1}
          >
            <div data-tooltip-id={`#${id}`} className={styles.tooltipContent}>
              {models.map((item) => (
                <div key={item.icon} className={styles.modelRow}>
                  <Icon
                    type={item.icon}
                    size={SVG_SIZE_S}
                    colorReverse={true}
                  />
                  <span>{item.models}</span>
                </div>
              ))}
            </div>
          </Tooltip>
        </div>
      </PortalWrapper>
    </>
  );
};
